import Module from '../utils/Module';

export default class ErrorModule extends Module {
  constructor (options) {
    super(options);

    this.init();
  }

  init () {
    this.trackPageView();
  }

  trackPageView() {
    dataLayer.push({
      "event": "contentInteraction",
      "interaction": {
        "category": "error page"
      }
    });
  }
}
